import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { reduxForm, Field } from 'redux-form'
import { TextField } from 'redux-form-material-ui'

import AlertMessage from '../../../../components/AlertMessage'
import { required, validEmail } from '../../../../utils/validators'
import FormFooter from  '../../../../components/FormFooter'
import CheckboxGroup from '../../components/CheckboxGroup'
import { PERMISSION_OPTIONS, SUBSIDIARY_OPTIONS } from '../../shared/static-options'

class LuftUserForm extends Component {
    _saveUser = (formValues) => {
        this.props.onSubmit(formValues)
    }

    render() {
        const { userData, onDismiss, onRemove, errorMessage, handleSubmit, invalid } = this.props

        return (
            <form onSubmit={handleSubmit(this._saveUser)}>
                <Field
                    name="name"
                    floatingLabelText="Nome"
                    fullWidth
                    component={TextField}
                    validate={required}
                />
                <Field
                    name="email"
                    floatingLabelText="E-mail"
                    fullWidth
                    component={TextField}
                    validate={[required, validEmail]}
                />
                <Field
                    name="subsidiaries"
                    props={{
                        label: 'Filial',
                        limitOptionsHeight: true,
                        options: SUBSIDIARY_OPTIONS,
                    }}
                    component={CheckboxGroup}
                />
                <Field
                    name="roles"
                    props={{
                        label: 'Configurar permissões',
                        options: PERMISSION_OPTIONS,
                    }}
                    component={CheckboxGroup}
                />
                {
                    errorMessage &&
                    <AlertMessage error box message={errorMessage} />
                }
                <FormFooter
                    entityName="usuário"
                    invalid={invalid}
                    onCancel={onDismiss}
                    onRemove={onRemove ? () => { onRemove(userData) } : null}
                />
            </form>
        )
    }
}

LuftUserForm.propTypes = {
    userData: PropTypes.object,
    onSubmit: PropTypes.func,
    onDismiss: PropTypes.func,
    onRemove: PropTypes.func,
    errorMessage: PropTypes.string,
}

// Redux
const mapStateToProps = (state, ownProps) => {
    const { userData } = ownProps

    return userData ?
        {
            initialValues: {
                id: userData.id,
                name: userData.name,
                email: userData.email,
                subsidiaries: userData.subsidiaries.map(subsidiary => subsidiary.id),
                roles: userData.roles.map(role => role.id),
            },
        } :
        {
            initialValues: {
                id: '',
                name: '',
                email: '',
                subsidiaries: [],
                roles: [],
            },
        }
}

export default connect(mapStateToProps)(reduxForm({ form: 'luftUser' })(LuftUserForm))
